import styled from 'styled-components';

export const ChatBox = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    positio: relative;
`;

export const ChatLog = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    padding: 20px;
    overflow: auto;
`;

export const ChatRawMessage = styled.div`
    color: #aaa;
    padding: 5px;
    font-size: 14px;
    width: 100%;
`;

export const ChatRawCommand = styled.div`
    color: #fda;
    padding: 10px;
    font-size: 14px;
    line-height: 22px;
    width: 100%;
    border: 1px solid #444;
    margin: 20px 0 40px;

    & span {
        font-family: monospace;
    }
`;

export const ChatSend = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 50px;
    width: 100%;
    border-top: 1px solid #444;
    wisth: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
`;

export const MessageInput = styled.input`
    background-color: #222;
    margin-left: 5px;
    height: 30px;
    border: 1px solid #444;
    padding-left: 3px;
    flex: 1;
    color: #fff;

    :focus {
        outline-color: #666;
    }
`;

export const MessageSend = styled.div`
    height: 30px;
    width: 30px;
    margin: 0 5px;
    border: 1px solid #444;
    position: relative;
    
    &:before {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        content: '\\F048A';
        font-family: "Material Design Icons";
    }
`;

export const DiceSend = styled.div`
    height: 30px;
    width: 30px;
    margin: 0 10px;
    border: 1px solid #444;
    position: relative;

    &:first-child {
        margin-left: 0;
    }

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        content: '\\F114F';
        font-family: "Material Design Icons";
    }
`;

export const DiceBlock = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 9px;
    background-color: #222;
    border-left: 1px solid #444;
    position: absolute;
    right: 0px;
    bottom: 0px;

    &.hide {
        display: none;
    }
`;

export const IsTyping = styled.div`
    position: absolute;
    bottom: 55px;
    right: 5px;
    color: #888;
    font-size: 12px;
    font-style: italic;
    opacity: 1;
    transition: all .3s ease 0s;

    &.hidden {
        opacity: 0;
    }
`;

export const DiceButton = styled.div`
    height: 30px;
    width: 30px;
    margin-left: 10px;
    border: 1px solid #444;
    position: relative;

    &:first-child {
        margin-left: 0;
    }

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        content: '${props => props.icon}';
        font-family: "Material Design Icons";
    }
`;
